import React, { useContext } from 'react';
import styled from 'styled-components';
import { TelegramUserContext } from '../App';

const UserInfo = styled.div`
  font-size: 14px;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  margin-top: 8px;
  width: 100%;
`;

const UserInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
`;

const UserInfoLabel = styled.span`
  font-weight: 600;
  color: #333;
`;

const UserInfoValue = styled.span`
  color: #555;
`;

const RegistrationStatus = () => {
  const telegramUser = useContext(TelegramUserContext);
  
  if (!telegramUser.id) {
    return null;
  }

  return (
    <UserInfo>
      <UserInfoRow>
        <UserInfoLabel>User ID:</UserInfoLabel>
        <UserInfoValue>{telegramUser.id}</UserInfoValue>
      </UserInfoRow>
      <UserInfoRow>
        <UserInfoLabel>Username:</UserInfoLabel>
        <UserInfoValue>
          {telegramUser.username !== 'User' ? `@${telegramUser.username}` : 'Not set'}
        </UserInfoValue>
      </UserInfoRow>
    </UserInfo>
  );
};

export default RegistrationStatus;